<ts-page-with-nav
  [appName]="(appName$ | async) || ''"
  [navData]="navData$ | async"
  [user]="user$ | async"
  [impersonatingUser]="(impersonatingUser$ | async) || false"
  [style.margin-right]="(globalPannel.visible | async) ? '4rem' : ''"
  [navPlatformData]="(navPlatformData$ | async) || []"
  [navProfileData]="navProfileData"
  homeLink="/home"
>
  <router-outlet></router-outlet>
  <frontend-global-side-panel #globalPannel></frontend-global-side-panel>
</ts-page-with-nav>
